<script setup lang="ts">
import ECSPInvestmentProcess from './components/investmentProcess/ecsp/ECSPInvestmentProcess.vue'
import { usePersonalAccountDataState } from './utilities/account/useAccountDataPersonal'
import { useWalletState } from './utilities/account/useWallet'
import NotificationContainer from './components/notification/NotificationContainer.vue'
import { useLegalAccountDataState } from './utilities/account/useAccountDataLegal'
import { isLegalProfile } from './utilities/investment-process/useUserProfileType'
import LoadingSpinner from './components/base/LoadingSpinner.vue'
import { onMounted, ref, shallowRef } from 'vue'
import { CampaignRegulatoryRequirement, getCampaignData } from './utilities/investment-process/useCampaign'
import DefaultInvestmentProcess from './components/investmentProcess/default/DefaultInvestmentProcess.vue'
import AltFgInvestmentProcess from './components/investmentProcess/altfg/AltFgInvestmentProcess.vue'
import VermAnlGInvestmentProcess from './components/investmentProcess/vermanlg/VermAnlGInvestmentProcess.vue'
import StockInvestmentProcess from './components/investmentProcess/stock/StockInvestmentProcess.vue'
import useEventStore from './utilities/useEvent'
import { getPlatformName } from './utilities/usePlatformSettings'

const loaded = ref(false)
if (isLegalProfile()) {
    const legalState = useLegalAccountDataState()
    legalState.fetchAccountData().then(() => {
        loaded.value = true
    })
} else {
    const state = usePersonalAccountDataState()
    state.fetchAccountData().then(() => {
        loaded.value = true
    })
}

const eventStore = useEventStore()

const walletState = useWalletState()
walletState.fetchWalletData()

const component = shallowRef()
const campaingData = getCampaignData()

onMounted(() => {
    eventStore.trackEvent({
        event: 'start_investment_process',
        data: {
            campaign_id: campaingData?.asset_data.asset_var_uid,
            asset_id: campaingData?.asset_data.asset_uid,
            step: 1,
        },
    })
    if (campaingData) {
        if (campaingData.asset_data.regulatory_requirements === CampaignRegulatoryRequirement.ECSP) {
            component.value = ECSPInvestmentProcess
        } else if (campaingData.asset_data.regulatory_requirements === CampaignRegulatoryRequirement.DEFAULT) {
            component.value = DefaultInvestmentProcess
        } else if (campaingData.asset_data.regulatory_requirements === CampaignRegulatoryRequirement.ALTFG) {
            component.value = AltFgInvestmentProcess
        } else if (campaingData.asset_data.regulatory_requirements === CampaignRegulatoryRequirement.VERMANLG) {
            component.value = VermAnlGInvestmentProcess
        } else if (campaingData.asset_data.regulatory_requirements === CampaignRegulatoryRequirement.STOCK_EMISSION) {
            component.value = StockInvestmentProcess
        }
    } else {
        console.error('No campaign data available')
    }
})
</script>

<template>
    <div class="wrapper">
        <NotificationContainer />
        <div v-if="loaded">
            <component :is="component" v-if="component" />
            <div v-else>The Regulatory Requirement is not supported yet. Please contact the support.</div>
        </div>
        <div v-else class="flex h-[65vh] items-center justify-center">
            <LoadingSpinner class="h-10 w-10 fill-primary" />
        </div>
    </div>
</template>
